import { gql } from "@apollo/client";

export const GET_FIELD_FLOWS = gql`
    query GetFieldFlows($moduleType: String!) {
        getFieldFlows(moduleType: $moduleType) {
            success
            message
            data
        }
    }
`;

export const GET_FIELD_FLOW_ANCESTORS = gql`
    query GetFieldFlowAncestors($moduleType: String!, $propertyId: String!) {
        getFieldFlowAncestors(moduleType: $moduleType, propertyId: $propertyId) {
            success
            data
        }
    }
`;
